import {
  useMeetingManager,
  useRosterState,
} from "amazon-chime-sdk-component-library-react";

export function useVideoGridSize() {
  const { roster } = useRosterState();

  const meetingManager = useMeetingManager();

  // Get local attendee ID to exclude it from remote tiles
  const localAttendeeId =
    meetingManager.meetingSession?.configuration.credentials?.attendeeId;

  const remoteAttendees = Object.entries(roster).filter(([attendeeId]) => {
    return attendeeId !== localAttendeeId;
  });

  const pageSize = 3;

  const totalPages = Math.ceil(remoteAttendees.length / pageSize);

  return {
    gridSize: remoteAttendees.length + 1,
    totalPages,
    pageSize,
  };
}

export default useVideoGridSize;
